<template>
  <div class="addCostDetails">
    <commonHeader :title="$t('home.AE')">
      <template #buttons>
        <el-button plain @click="submitAdd">{{ $t('btn.Submit') }}</el-button>
        <el-button plain @click="cancelBtn">{{ $t('btn.Cancel') }}</el-button>
      </template>
    </commonHeader>
    <div class="common_group">
      <el-form class="common_form" label-position="left" ref="addCostDetailsForm" :rules="rules" :label-width="lang === 'zh-CN' ? '120px':'210px'" :model="formData">
        <el-row>
          <el-col :span="8">
            <el-form-item :label="$t('newApp.BasicInfo.cs')" prop="salerId">
              <el-select
                v-model="formData.salerId"
                filterable
                remote
                reserve-keyword
                :placeholder="$t('general.peak')"
                :remote-method="remoteMethod"
                :loading="saleLoading"
                @change="applyUserChange"
              >
                <el-option v-for="item in saleList" :key="item.userId" :label="item.combination" :value="item.userId" />
              </el-select>
            </el-form-item>
          </el-col>
          <!-- 费用归属部门 -->
          <el-col :span="8">
            <el-form-item :label="$t('newApp.Attribute.cad')" prop="deptCode">
              <el-select v-model="formData.deptCode" :disabled="readOnlyMode" :placeholder="$t('general.ps')" @change="activityDeptCodeChange">
                <el-option v-for="item in expenseDeptList" :key="item.id" :label="item.deptName" :value="item.deptCode" />
              </el-select>
            </el-form-item>
          </el-col>
          <!-- 费用类型 -->
          <el-col :span="8">
            <el-form-item :label="$t('newApp.Attribute.toe')" prop="expenseTypeCode">
              <el-select v-model="formData.expenseTypeCode" :disabled="readOnlyMode" :placeholder="$t('general.ps')" @change="activityExpenseTypeCodeChange">
                <el-option v-for="item in expenseTypeList" :key="item.id" :label="item.expenseTypeName" :value="item.expenseTypeCode" />
              </el-select>
            </el-form-item>
          </el-col>
          <!-- 细分市场 -->
          <el-col :span="8">
            <el-form-item :label="$t('newApp.Attribute.ms')" prop="subMarketCode">
              <el-select v-model="formData.subMarketCode" :disabled="readOnlyMode" :placeholder="$t('general.ps')" @change="activitySubMarketCodeChange">
                <el-option v-for="item in marketList" :key="item.id" :label="item.marketSegment" :value="item.marketSegment" />
              </el-select>
            </el-form-item>
          </el-col>
          <!-- 产品线 -->
          <el-col :span="8" v-if="formData.deptCode ==='000013' || formData.deptCode ==='000013004' ">
            <el-form-item :label="$t('newApp.Attribute.pl')" prop="productLine">
              <el-select v-model="formData.productLine" :disabled="readOnlyMode" :placeholder="$t('general.ps')" @change="activityProductLineChange">
                <el-option v-for="item in productLineList" :key="item.fieldKey" :label="item.fieldValue" :value="item.fieldValue" />
              </el-select>
            </el-form-item>
          </el-col>
          <!-- 单场费用上限 -->
          <el-col v-if="getRowTemplateCost(formData)" :span="8">
            <el-form-item :label="$t('industryReport.hybblb.list.dcfysx')" class="especial">
              <div class="text">{{ getRowTemplateCost(formData).singleActivityExpenseLimit }}</div>
            </el-form-item>
          </el-col>
          <!-- 预算余额 -->
          <el-col :span="8">
            <el-form-item :label="$t('newApp.Attribute.bb')" class="especial">
              <div class="text">{{realBudget }}</div>
            </el-form-item>
          </el-col>
          <!-- 财务体系 -->
          <el-col :span="8">
            <el-form-item :label="$t('newApp.BasicInfo.fs')" prop="financialSystemCode">
              <el-select v-model="formData.financialSystemCode" :placeholder="$t('general.ps')" @change="financialSystemCodeChange">
                <el-option v-for="item in financialSystemList" :key="item.code" :label="lang === 'zh-CN' ? item.shortName : item.englishShortName" :value="item.code" />
              </el-select>
            </el-form-item>
          </el-col>
          <!-- 货币种类 -->
          <el-col :span="8">
            <el-form-item :label="$t('newApp.BasicInfo.toc')" prop="currencyCode">
              <el-select v-model="formData.currencyCode" :disabled="allsmartOrderVOList.length > 0" :placeholder="$t('general.ps')" @change="currencyCodeChange">
                <el-option v-for="item in (getRowTemplateCost(formData) && getRowTemplateCost(formData).stat !== 107) ? templateWriteoffCurrency : writeoffCurrency" :key="item.code" :label="lang === 'zh-CN' ? item.name :item.code" :value="item.code" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <!--        <el-row :gutter="70">-->
        <!--          <el-col :span="8">-->
        <!--            <el-form-item label="申请金额">-->
        <!--              {{ costTotal }}-->
        <!--            </el-form-item>-->
        <!--          </el-col>-->
        <!--        </el-row>-->
      </el-form>
    </div>
    <div class="common_group">
      <div class="title">
        <img src="@/assets/images/costIcon.png">
        <span>{{ $t('newApp.Attribute.dcoa') }}</span>
        <div class="buttonBar">
          <el-button type="primary" @click="addActRow">{{ $t('newApp.Attribute.aar') }}</el-button>
        </div>
      </div>
      <commonTable
        ref="activityCostTable"
        :footer-cost="{ label: $t('newApp.Attribute.hdfyzj'), val: activityMoney }"
      />
      <div class="common_readonly_template">
        <el-row>
          <el-col :span="24">
            <div>
              <div class="label">{{ $t('newApp.Attribute.hdfybz') }}</div>
              <div class="text">
                <el-input v-model="activityCostRemarks" type="textarea" maxlength="500" show-word-limit />
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <div class="common_group" v-if="callbackUrl === '/activityDetails'">
      <div class="title">
        <img src="@/assets/images/costIcon.png">
        <span>{{ $t('newApp.Attribute.breakdownAdvertising') }}</span>
        <div class="buttonBar">
          <el-button type="primary" :disabled="formData.currencyCode !== 'CNY'" v-if="!ifGoodsEdit" @click="toOrder">{{ $t('newApp.Attribute.qxd') }}</el-button>
          <el-button type="primary" v-else @click="toOrder">编辑订单</el-button>
        </div>
      </div>
      <commonTable
        ref="advertCostTable"
        :footer-cost="{ label: $t('newApp.Attribute.ggfyzj'), val: rowData.advertisingCost }"
      />
      <div class="common_readonly_template">
        <el-row>
          <el-col
            :span="6"
            :xs="12" :sm="12" :md="12" :lg="8" :xl="6"
            v-show="rowData.advertiseExpenseDetails.consigneeName"
          >
            <div>
              <div class="label">收货人</div>
              <div class="text">
                <span>{{ rowData.advertiseExpenseDetails.consigneeName }}</span>
              </div>
            </div>
          </el-col>
          <el-col
            :xs="12" :sm="12" :md="12" :lg="16" :xl="6"
            v-show="rowData.advertiseExpenseDetails.consigneeName"
          >
            <div>
              <div class="label">{{ $t('newApp.BasicInfo.ci') }}</div>
              <div class="text">
                <span>{{ rowData.advertiseExpenseDetails.consigneeTel }}</span>
              </div>
            </div>
          </el-col>
          <el-col
            :xs="24" :sm="24" :md="24" :lg="24" :xl="12"
            v-show="rowData.advertiseExpenseDetails.consigneeName"
          >
            <div>
              <div class="label">收货地址</div>
              <div class="text customStyle">
                <span>{{ rowData.advertiseExpenseDetails.province }}</span>
                <span>{{ rowData.advertiseExpenseDetails.city }}</span>
                <span>{{ rowData.advertiseExpenseDetails.area }}</span>
                <span v-if="rowData.advertiseExpenseDetails.street">{{ rowData.advertiseExpenseDetails.street }}</span>
                <span>{{ rowData.advertiseExpenseDetails.detailedAddress }}</span>
              </div>
            </div>
          </el-col>
          <el-col :span="24">
            <div>
              <div class="label">{{ $t('newApp.Attribute.fygsbz') }}</div>
              <div class="text">
                <el-input v-model="note" type="textarea" maxlength="500" show-word-limit />
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <advertDialog :advert-dialog-visible="advertDialogVisible" :car-flage-show="ifGoodsEdit" :current-row="temporaryData" @submitHandle="advertSubmitHandle" @dialogCloseHandle="advertDialogClose" />
    <costConfirmDialog :cost-confirm-data="costConfirmData" :cost-confirm-dialog-visible="costConfirmDialogVisible" @submitHandle="costConfirmBtn" @dialogCloseHandle="costConfirmDialogClose" />
  </div>
</template>

<script>
import commonHeader from '@/components/commonHeader';
import commonTable from 'components/commonTable';
import { TableColumns, TableRow } from '@/utils/tableOptions';
import { newApplicationFormApi } from '@/views/newApplicationForm/service';
import { activityQueryDetails } from '@/views/activitieList/service';
import { confirmAllsmartOrderTimeout } from '@/utils/allsmartOrderCheck';
import advertDialog from '@/views/newApplicationForm/component/costAscription/advertDialog';
import costConfirmDialog from './costConfirmDialog';
import { arrayQuery, isNotEmpty } from '@/utils/utils';

export default {
  data () {
    return {
      rules: {
        salerId: [
          { required: true, message: this.$t('newApp.BasicInfo.pstcs'), trigger: 'change' }
        ],
        deptCode: [
          { required: true, message: this.$t('newApp.Attribute.pstcad'), trigger: 'change' }
        ],
        expenseTypeCode: [
          { required: true, message: this.$t('newApp.Attribute.psaft'), trigger: 'change' }
        ],
        subMarketCode: [
          { required: true, message: this.$t('newApp.Attribute.psams'), trigger: 'change' }
        ],
        productLine: [
          { required: true, message: this.$t('newApp.activityInfo.psapl'), trigger: 'change' }
        ],
        financialSystemCode: [
          { required: true, message: this.$t('newApp.BasicInfo.psafs'), trigger: 'change' }
        ],
        currencyCode: [
          { required: true, message: this.$t('newApp.BasicInfo.psac'), trigger: 'change' }
        ]
      },
      formData: {},
      activityCostRemarks: '', // 活动费用明细备注
      note: '', // 费用归属备注
      expenseDeptList: [], // 费用归属部门列表
      expenseTypeList: [], // 费用类型列表
      marketList: [], // 细分市场列表,
      productLineList: [], // 产品线列表
      projectConentList: [], // 项目内容列表
      readOnlyMode: false,
      activityCode: '', // 市场活动code
      realBudget: 0, // 预算余额
      activityTableData: [{
        amount: 0,
        price: 0
      }], // 活动明细表数据
      advertTableData: [], // 广告品明细表数据
      activityMoney: 0.00,
      advertDialogVisible: false,
      temporaryData: {},
      rowData: {
        advertiseExpenseDetails: {
          advertiseOrderDetails: []
        },
        advertisingCost: 0.00
      },
      ifGoodsEdit: false, // 控制下单按钮的显示和广告品页面中“我的选择”的显隐
      submitBtnFlage: false, // 提交按钮点击标识，是否点了提交
      saleLoading: false,
      saleList: [],
      costConfirmDialogVisible: false,
      costConfirmData: {},
      salerObj: {}, // 搜索出的销售实体类
      callbackUrl: '',
      expCode: '',
      timer: null,
      addGiftStatus: false,
      allsmartOrderVOList: [],
      lang: localStorage.getItem('lang') || 'zh-CN',
      financialSystemList: [],
      writeoffCurrency: [],
      templateFinancialSystemList: [],
      templateWriteoffCurrency: [],
      currentFinancialSystem: null,
      echoData: {},
      industryReportActivityCode: '', // 行业报备关联的行业模板活动编码
      remainAvailableAmountList: [], // 行业报备模板费用列表
      relationActivityList: [], // 关联活动列表
      activitySource: null // 关联活动来源
    };
  },
  components: {
    commonHeader,
    commonTable,
    advertDialog,
    costConfirmDialog
  },
  computed: {
    costTotal () {
      return (Number(this.rowData.advertisingCost) + Number(this.activityMoney)).toFixed(2);
    },
    calcSingleActivityExpenseLimit () {
      return (row) => {
          const dataInfo = this.getRowTemplateCost(row);
          if (isNotEmpty(dataInfo)) {
          // 小池子费用超过单场费用上限那么用单场费用上限额度，没有则用小池子剩余额度
          const bigCost = this.realBudget > dataInfo.singleActivityExpenseLimit ? dataInfo.singleActivityExpenseLimit : this.realBudget;
          const smallCost = dataInfo.remainAvailableAmount > dataInfo.singleActivityExpenseLimit ? dataInfo.singleActivityExpenseLimit : dataInfo.remainAvailableAmount;
          const singleActivityExpenseLimit = (dataInfo.stat !== 107 ? smallCost * 1 : bigCost) || 0;
          const dataList = this.echoData.mactExpenseBelongVOList;
          const reportApplyAmountList = dataList.map(item => row.deptCode === item.mactExpenseBelong.deptCode && item.mactExpenseBelong.expenseTypeCode === 'EI201' && item.mactExpenseBelong.stat !== 104 ? item.mactExpenseBelong.activityCost + item.mactExpenseBelong.advertisingCost : 0);
          // 已使用费用
          const maximumOccupancyCost = reportApplyAmountList.reduce((num, val) => num + val, 0);
          // 单场费用上限 - 已使用费用 = 可用余额
          // 可用余额大于0，返回可用余额，小于0返回0
          return (singleActivityExpenseLimit - maximumOccupancyCost) > 0 ? singleActivityExpenseLimit - maximumOccupancyCost : 0;
        } else {
          return '-';
        }
      };
    }
  },
  methods: {
    getRowTemplateCost (row) {
      if (this.remainAvailableAmountList.length < 0 || row.expenseTypeCode !== 'EI201') {
        return null;
      };
      const data = this.remainAvailableAmountList.find(item => row.deptCode === item.deptCode && row.expenseTypeCode === item.expenseTypeCode);
      return isNotEmpty(data) ? data : null;
    },
    getEchoData () {
      // 请求接口 获取响应数据 传参 报备编码
      activityQueryDetails.getBasicInfoData(this.$route.query.activityCode).then(res => {
        if (res.status === '200') {
          this.echoData = res.data; // 申请全部数据暂存
          if (res.data.marketActivity.industryReportActivityCode) {
            this.industryReportActivityCode = res.data.marketActivity.industryReportActivityCode; // 行业报备关联的行业模板活动编码
            this.getQueryRemainAvailableAmount();
          }
          // 行业模板时获取列表
          if (this.echoData.marketActivityExpand.marketingForm === 1 && this.echoData.marketActivity.activityClassificationCode === 'AC_01') {
            this.getTemplateActivity();
          } else {
            this.getExpenseDeptList(this.$store.state.userInfo.sysUser.deptCode);
          }
        }
      });
    },
    // 获取模板活动
    getTemplateActivity () {
      const params = 'NEW';
      newApplicationFormApi.getTemplateActivity(params).then(res => {
        this.relationActivityList = res.data.map(item => {
          return {
            code: item.id + '',
            text: item.templateName,
            activityType: item.activityType,
            activityTypeCode: item.activityTypeCode,
            activitySubType: item.activitySubType,
            activityGoal: item.activityGoal,
            sourceLink: item.sourceLink ? item.sourceLink : '',
            activityCode: item.activityCode,
            activitySource: item.activitySource
          };
        });
        const currentInfo = this.relationActivityList.find(item => item.code === this.echoData.marketActivity.relatedActivityCode);
        if (isNotEmpty(currentInfo)) {
          this.activitySource = currentInfo.activitySource;
        }
        this.getExpenseDeptList(this.$store.state.userInfo.sysUser.deptCode);
      });
    },
    // 获取行业报备模板费用
    getQueryRemainAvailableAmount () {
      const activityCode = this.industryReportActivityCode;
      newApplicationFormApi.queryRemainAvailableAmount(activityCode).then(res => {
        if (res.status === '200') {
          if (isNotEmpty(res.data)) {
            this.remainAvailableAmountList = res.data;
          }
        }
      });
    },
    // 财务体系&货币种类列表
    getFinancialSystemCommand (userId) {
      newApplicationFormApi.getFinancialList(userId).then(res => {
        if (res.status === '200') {
          if (isNotEmpty(res.data)) {
            const result = JSON.parse(JSON.stringify(res.data));
            const templateResult = JSON.parse(JSON.stringify(res.data));
            this.templateFinancialSystemList = templateResult.map(item => {
              item.writeoffCurrency = item.writeoffCurrency.filter(ite => ite.code === 'CNY');
              return item;
            });
            this.templateWriteoffCurrency = this.templateFinancialSystemList[0].writeoffCurrency;
            let currentCreateData = null; // 查询福建数据
            this.financialSystemList = result;
            this.writeoffCurrency = result[0].writeoffCurrency;
            const createIndex = this.financialSystemList.findIndex(ite => ite.code === '111');
            if (createIndex !== -1) {
              currentCreateData = this.financialSystemList[createIndex];
            }
            this.currentFinancialSystem = createIndex !== -1 ? currentCreateData.currencyCode : result[0].currencyCode;
            this.$set(this.formData, 'currencyCode', this.writeoffCurrency[0].code);
            this.$set(this.formData, 'financialSystemCode', createIndex !== -1 ? currentCreateData.code : result[0].code);
            this.$set(this.formData, 'currencyType', this.lang === 'zh-CN' ? this.writeoffCurrency[0].name : this.writeoffCurrency[0].code);
            if (createIndex !== -1) {
              this.$set(this.formData, 'financialSystemName', this.lang === 'zh-CN' ? currentCreateData.shortName : currentCreateData.englishShortName);
            } else {
              this.$set(this.formData, 'financialSystemName', this.lang === 'zh-CN' ? result[0].shortName : result[0].englishShortName);
            }
          }
        }
      });
    },
    financialSystemCodeChange (e) {
      const currentData = this.financialSystemList.find(item => item.code === e);
      this.$set(this.formData, 'financialSystemName', currentData.shortName);
      if (this.formData.expenseTypeCode) {
        let params = {
          deptCode: this.formData.deptCode,
          expenseTypeCode: this.formData.expenseTypeCode,
          currentFinancialSystem: this.currentFinancialSystem,
          localCurrencyCode: this.formData.currencyCode
        };
        newApplicationFormApi.getRealBudgetBalance(params).then(res => {
          if (res.status === '200') {
            this.realBudget = res.data;
          } else {
            this.realBudget = 0;
            this.formData.currencyCode = null;
          }
        });
      }
    },
    currencyCodeChange (e) {
      const currentData = this.writeoffCurrency.find(item => item.code === e);
      this.$set(this.formData, 'currencyType', currentData.name);
      if (this.formData.expenseTypeCode) {
        let params = {
          deptCode: this.formData.deptCode,
          expenseTypeCode: this.formData.expenseTypeCode,
          currentFinancialSystem: this.currentFinancialSystem,
          localCurrencyCode: this.formData.currencyCode
        };
        newApplicationFormApi.getRealBudgetBalance(params).then(res => {
          if (res.status === '200') {
            this.realBudget = res.data;
          } else {
            this.realBudget = 0;
            this.formData.currencyCode = null;
          }
        });
      }
    },
    getExpCodeCommand () {
      newApplicationFormApi.getExpCode().then(res => {
        if (res.status === '200') {
          this.expCode = res.data;
        }
      });
    },
    applyUserChange (val) {
      this.$set(this.formData, 'deptCode', '');
      this.$set(this.formData, 'expenseTypeCode', '');
      this.$set(this.formData, 'subMarketCode', '');
      this.realBudget = 0;
      this.expenseDeptList = [];
      this.expenseTypeList = [];
      this.marketList = [];
      this.$nextTick(() => {
        this.$refs.addCostDetailsForm.clearValidate();
      });
      this.getFinancialSystemCommand(val);
      this.salerObj = arrayQuery(val, this.saleList, 'userId');
      this.getExpenseDeptList(this.salerObj.deptCode);
    },
    costConfirmDialogClose () {
      this.costConfirmDialogVisible = false;
    },
    remoteMethod (query) {
      if (query !== '') {
        this.saleLoading = true;
        newApplicationFormApi.getSalesmanList(query).then(res => {
          if (res.status === '200') {
            if (res.data && res.data.length > 0) {
              this.saleList = res.data.map(item => {
                return {
                  ...item,
                  combination: `${item.userName}/${item.deptName}`
                };
              });
            } else {
              this.saleList = [];
            }
          }
          this.saleLoading = false;
        });
      } else {
        this.saleList = [];
      }
    },
    advertDialogClose () {
      this.advertDialogVisible = false;
    },
    advertSubmitHandle (val) {
      this.rowData.advertiseExpenseDetails = val.formData;
      this.rowData.advertiseExpenseDetails.advertiseOrderDetails = val.goodsList;
      this.ifGoodsEdit = val.goodsList.length > 0;
      this.rowData.advertisingCost = val.total;
      this.rowData.applyAmount = val.total;
      this.submitBtnFlage = true;
      this.advertDialogVisible = false;
      this.loadAdvertCostTable();
    },
    addActRow () {
      this.$refs.activityCostTable.insertRow({
        amount: 0,
        price: 0
      });
    },
    deleteBtn (row) {
      this.$refs.activityCostTable.removeRow(row);
      this.moneyCount();
    },
    toOrder () {
      if (!this.addGiftStatus) {
        this.findAllsmartOrderVOList();
        this.addGiftStatus = true;
      }
      const { sysUser } = this.$store.state.userInfo;
      const eventcode = this.activityCode;
      const expensecode = this.expCode;
      const rjPercode = sysUser.userId;
      const params = {
        method: 'gift_select',
        reqData: `<?xml version="1.0" encoding="utf-8"?><body><eventcode>${eventcode}</eventcode><expensecode>${expensecode}</expensecode><rj_percode>${rjPercode}</rj_percode><lang>${this.lang === 'zh-CN' ? 'zh_cn' : 'en_us'}</lang></body>`,
        lang: this.lang === 'zh-CN' ? 'zh_cn' : 'en_us'
      };
      newApplicationFormApi.getGiftUrl(params).then(res => {
        if (res.status === '200') {
          window.open(res.data);
        }
      });
    },
    findAllsmartOrderVOList (res) {
      this.timer = null;
      clearTimeout(this.timer);
      this.getDetailCommand();
      if (!res) {
        this.timer = setTimeout(() => {
          this.findAllsmartOrderVOList();
        }, 15000);
      };
    },
    async getDetailCommand () {
      let params = {
        eventCode: this.activityCode, // 'RJM2302140018',
        expCode: this.expCode // '07ec40a8e98b4137abeaa42efe1677cd'
      };
      newApplicationFormApi.getDetailsAll(params).then(res => {
        if (res.status === '200') {
          if (isNotEmpty(res.data)) {
            const { orderlist } = res.data;
            const odrAmount = orderlist.map(item => item.odrAmount * 1).reduce((x, y) => x + y);
            this.rowData.advertisingCost = odrAmount;
            let allsmartOrderVOList = [];
            let orderList = [];
            orderlist.forEach(item => {
                orderList = orderList.concat(item.osubList.map((ite, i) => {
                  const params = {
                    productName: ite.productName,
                    prodId: ite.prodid,
                    unitprice: ite.unitprice,
                    buynum: ite.buynum,
                    osubAmount: ite.osub_amount,
                    operateStatus: i === 0 ? 1 : 0,
                    prodCode: item.odrCode
                  };
                  return params;
                }));
              allsmartOrderVOList.push({
                prodCode: item.odrCode,
                expCode: this.expCode,
                odrAmount: item.osubList.map(ite => ite.osub_amount * 1).reduce((x, y) => x + y),
                productList: item.osubList.map(ite => {
                  const params = {
                    productName: ite.productName,
                    prodId: ite.prodid,
                    unitprice: ite.unitprice,
                    buynum: ite.buynum,
                    osubAmount: ite.osub_amount
                  };
                  return params;
                })
              });
            });
            this.advertTableData = orderList;
            this.allsmartOrderVOList = allsmartOrderVOList;
            if (isNotEmpty(allsmartOrderVOList)) {
              if (this.formData.currencyCode !== 'CNY') {
                  const currentData = this.writeoffCurrency.find(item => {
                    return item.code === 'CNY';
                  });
                  this.formData.currencyCode = currentData.code;
                  this.formData.currencyType = currentData.name;
                }
            }
            this.rowData.orderList = orderList;
            this.loadAdvertCostTable();
          } else {
            this.rowData.orderList = [];
            this.allsmartOrderVOList = [];
            this.loadAdvertCostTable();
          }
        }
      });
    },
    getExpenseDeptList (code) {
      let params = {
        deptCode: code,
        activityClassification: this.$route.query.activityClassificationCode,
        activityType: this.callbackUrl === '/reportDetails' ? 2 : 1
      };
      if (this.industryReportActivityCode) {
        params.activityCode = this.industryReportActivityCode;
        params.activitySource = this.activitySource;
      }
      newApplicationFormApi.getExpenseDeptList(params).then(res => {
        if (res.status === '200') {
          this.expenseDeptList = res.data;
        }
      });
    },
    filterExpenseTypeList (typeList) {
      if (typeList && typeList.length > 0) {
        // 过滤1： 如果没有选择渠道签约类型且对应销售属于smb部门，则费用类型中不包括SMB区域市场基金
        if (!this.$route.query.unionChannelName && this.salerObj.belongToSmb) {
          return typeList.filter(item => {
            if (item.expenseTypeName !== 'SMB区域市场基金') {
              return item;
            }
          });
        }
        // 过滤2： 活动分类为AC_01(行业模板活动)、AC_03(区域参与总部活动)、AC_06(总部活动)时允许模板费用，其余过滤
        // 数字营销(marketingForm=2)不允许使用模板费用
        const classCode = this.$route.query.activityClassificationCode;
        const allowTemplateCost = ['AC_01', 'AC_03', 'AC_06'].includes(classCode);
        const isDigitalMarketing = this.echoData && this.echoData.marketActivityExpand && this.echoData.marketActivityExpand.marketingForm === 2;
        if (!allowTemplateCost || isDigitalMarketing) {
          return typeList.filter(item => {
            if (item.expenseTypeName !== '营销费用-模板活动') {
              return item;
            }
          });
        }
        // 如果都不满足以上两条过滤条件则之间返回全部费用类型
        return typeList;
      }
    },
    getMarketList (code) {
      newApplicationFormApi.getMarketList(code).then(res => {
        if (res.status === '200') {
          this.marketList = res.data;
        }
      });
    },
    getProductLineList () {
      newApplicationFormApi.getProductLineList().then(res => {
        if (res.status === '200') {
          this.productLineList = res.data;
        }
      });
    },
    getExpenseOptionList () {
      newApplicationFormApi.getExpenseOptionList().then(res => {
        if (res.status === '200') {
          this.projectConentList = res.data;
          this.loadActivityCostTable();
        }
      });
    },
    moneyCount (row) {
      if (row) {
        row.price = row.price ? Number(row.price) : 0;
        row.amount = row.amount ? Number(row.amount) : 0;
        row.total = (row.price * row.amount).toFixed(2);
      }
      let activityMoney = this.activityTableData.reduce((current, item) => {
        return current + Number(item.total);
      }, 0);
      this.activityMoney = activityMoney.toFixed(2);
    },
    cancelBtn () {
      this.$router.go(-1);
    },
    submitAdd () {
      this.$refs['addCostDetailsForm'].validate((valid) => {
        if (valid) {
          // 如果活动费用明细不为0，且广告品费用明细不为空
          // if (!(this.activityMoney > 0 || this.rowData.advertiseExpenseDetails.advertiseOrderDetails.length > 0)) {
          //   this.$message.error('请完善费用明细');
          //   return;
          // }
          let activityTableDataValid = true;
          for (let i = 0; i < this.activityTableData.length; i++) {
            if (!this.activityTableData[i].content) {
              // 如果有一项活动费用明细的项目内容为空则返回
              activityTableDataValid = false;
              this.$message.error('请完善活动费用明细中的项目内容');
              break;
            }
          }
          let salerName = arrayQuery(this.formData.salerId, this.saleList, 'userId').userName;
          let deptName = arrayQuery(this.formData.deptCode, this.expenseDeptList, 'deptCode').deptName;
          let expenseTypeName = arrayQuery(this.formData.expenseTypeCode, this.expenseTypeList, 'expenseTypeCode').expenseTypeName;
          this.costConfirmData = {
            salerName,
            deptName,
            expenseTypeName,
            costTotal: this.costTotal,
            advertisingCost: this.rowData.advertisingCost,
            activityMoney: this.activityMoney,
            activityCode: this.activityCode
          };
          this.costConfirmDialogVisible = activityTableDataValid && true;
        }
      });
    },
    async costConfirmBtn () {
      let params = {
        mactExpenseBelong: this.formData,
        activityExpenseDetails: [],
        advertiseExpenseDetails: {}
      };
      params.mactExpenseBelong.salerName = arrayQuery(this.formData.salerId, this.saleList, 'userId').userName;
      params.mactExpenseBelong.activityCode = this.activityCode;
      let deptObj = arrayQuery(this.formData.deptCode, this.expenseDeptList, 'deptCode');
      params.mactExpenseBelong.deptName = deptObj.deptName;
      // 细分市场本身没有code，默认与名称相同
      params.mactExpenseBelong.subMarket = this.formData.subMarketCode;
      let expenseTypeObj = arrayQuery(this.formData.expenseTypeCode, this.expenseTypeList, 'expenseTypeCode');
      params.mactExpenseBelong.expenseType = expenseTypeObj.expenseTypeName;
      params.mactExpenseBelong.budgetLeftAmount = this.realBudget;
      params.mactExpenseBelong.applyAmount = this.costTotal;
      params.mactExpenseBelong.activityCost = this.activityMoney;
      params.mactExpenseBelong.advertisingCost = this.rowData.advertisingCost;
      params.mactExpenseBelong.expenseDetailNote = this.activityCostRemarks;
      params.mactExpenseBelong.note = this.note;
      params.mactExpenseBelong.expCode = this.expCode;
      params.activityExpenseDetails = this.activityTableData;
      // params.advertiseExpenseDetails = this.rowData.advertiseExpenseDetails;
      // params.advertiseExpenseDetails.totalMoney = this.rowData.advertisingCost;
      params.allsmartOrderVOList = this.allsmartOrderVOList;
      // 礼品汇超时规则确认弹窗
      const allsmartConfirmed = await confirmAllsmartOrderTimeout(this, this.allsmartOrderVOList && this.allsmartOrderVOList.length > 0);
      if (!allsmartConfirmed) return;
      this.activityTableData.forEach(item => {
        if (!item.content) {
          // 如果有一项活动费用明细的项目内容为空则返回
          this.$message.error('请完善活动费用明细中的项目内容');
        }
      });
      // if (this.getRowTemplateCost(this.formData) && this.calcSingleActivityExpenseLimit(this.formData) > 0 && this.calcSingleActivityExpenseLimit(this.formData) < this.costTotal * 1) {
      //   return this.$message.error(`申请金额不能超过单场费用上限`);
      // }
      let requestUrl = newApplicationFormApi.additionalExpense;
      if (this.callbackUrl === '/reportDetails') {
        requestUrl = newApplicationFormApi.reportAdditionalExpense;
      }
      this.$store.commit('setSubPageLoading', true);
      requestUrl(params).then(res => {
        this.$store.commit('setSubPageLoading', false);
        if (res.status === '200') {
          this.$router.push({
            path: this.callbackUrl,
            query: {
              activityCode: this.activityCode,
              activeName: 'activityBasicInformation',
              addCostFlag: 1
            }
          });
        }
        this.$store.commit('setSubPageLoading', false);
      });
    },
    loadActivityCostTable () {
      let tableRow = new TableRow();
      tableRow.push(
        new TableColumns()
          ._title(this.$t('newApp.Attribute.pc'))
          ._data('content')
          ._width('220')
          ._cellType('customSelect')
          ._cellData({
            options: this.projectConentList,
            optionProps: {
              label: 'fieldValue',
              value: 'fieldValue'
            }
          })
      );
      tableRow.push(
        new TableColumns()
          ._title(this.$t('newApp.Attribute.pup'))
          ._data('price')
          ._width('220')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
              return (
                <el-input-number
                  v-model={ row[column.property] }
                  min={ 0 }
                  controls={ false }
                  precision={ 2 }
                  onChange={() => { this.moneyCount(row); }}
                />
              );
            }
          })
      );
      tableRow.push(
        new TableColumns()
          ._title(this.$t('newApp.Attribute.nop'))
          ._data('amount')
          ._width('220')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
              return (
                <el-input-number
                  v-model={ row[column.property] }
                  min={ 1 }
                  precision={ 0 }
                  onChange={() => { this.moneyCount(row); }}
                />
              );
            }
          })
      );
      tableRow.push(
        new TableColumns()
          ._title(this.$t('newApp.Attribute.sp'))
          ._data('total')
          ._width('220')
      );
      tableRow.push(
        new TableColumns()
          ._title(this.$t('general.Operation'))
          ._width('220')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
              return (
                <div>
                  <el-button type="text" onClick={() => { this.deleteBtn(row); }}>{this.$t('btn.Delete')}</el-button>
                </div>
              );
            }
          })
      );
      let column = tableRow._cols();
      this.$nextTick(() => {
        this.$refs.activityCostTable.setColumn(column, {
          page: false
        });
        this.$refs.activityCostTable.loadStaticTable(this.activityTableData);
      });
    },
    loadAdvertCostTable () {
      let tableRow = new TableRow();
      tableRow.push(
        new TableColumns()
          ._width('200')
          ._title(this.$t('newApp.ADList.noa'))
          ._data('productName')
      );
      tableRow.push(
        new TableColumns()
          ._width('200')
          ._title(this.$t('newApp.ADList.up'))
          ._data('unitprice')
      );
      tableRow.push(
        new TableColumns()
          ._width('200')
          ._title(this.$t('newApp.Attribute.nop'))
          ._data('buynum')
      );
      tableRow.push(
        new TableColumns()
          ._width('200')
          ._title(this.$t('newApp.Attribute.sp'))
          ._data('osubAmount')
      );
      tableRow.push(
        new TableColumns()
          ._title(this.$t('general.Operation'))
          ._width('220')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
              if (row.operateStatus === 1) {
                return (
                  <div>
                    <el-button type="text" onClick={() => { this.deleteOrder(row); }}>删除</el-button>
                  </div>
                );
              }
            }
          })
      );
      let column = tableRow._cols();
      this.$nextTick(() => {
        this.$refs.advertCostTable.setColumn(column, {
          page: false
        });
        this.$refs.advertCostTable.loadStaticTable(this.rowData.orderList);
      });
    },
    deleteOrder (row) {
      const params = {
        orderCode: row.prodCode,
        eventCode: this.activityCode
      };
      // let { dataList } = this.$refs.advertCostTable.tableData;
      // const dataFilterList = dataList.filter(item => item.prodCode === row.prodCode);
      // if (isNotEmpty(dataFilterList)) {
      //   dataFilterList.forEach(item => {
      //     this.$refs.advertCostTable.removeRow(item);
      //   });
      // }
      newApplicationFormApi.deleteOrderCode(params).then(res => {
        if (res.status === '200') {
          this.$message.success('删除成功');
          this.findAllsmartOrderVOList('success');
        }
      });
    },
    activityDeptCodeChange (val) {
      this.$set(this.formData, 'expenseTypeCode', '');
      this.$set(this.formData, 'subMarketCode', '');
      this.realBudget = 0;
      this.expenseTypeList = [];
      this.marketList = [];
      this.$nextTick(() => {
        this.$refs.addCostDetailsForm.clearValidate();
      });
      let typeList = arrayQuery(val, this.expenseDeptList, 'deptCode').expenseTypeList;
      this.expenseTypeList = this.filterExpenseTypeList(typeList);
      this.getMarketList(val);
    },
    activitySubMarketCodeChange () {

    },
    activityProductLineChange () {

    },
    activityExpenseTypeCodeChange () {
      let params = {
        deptCode: this.formData.deptCode,
        expenseTypeCode: this.formData.expenseTypeCode,
        currentFinancialSystem: this.currentFinancialSystem,
        localCurrencyCode: this.formData.currencyCode
      };
      newApplicationFormApi.getRealBudgetBalance(params).then(res => {
        if (res.status === '200') {
          this.realBudget = res.data;
        }
      });
    }
  },
  mounted () {
    this.activityCode = this.$route.query.activityCode;
    this.getEchoData();
    this.callbackUrl = this.$route.query.callback;
    this.formData.salerId = this.$store.state.userInfo.sysUser.userId;
    this.getFinancialSystemCommand(this.formData.salerId);
    this.getExpCodeCommand();
    this.remoteMethod(this.$store.state.userInfo.sysUser.userId);
    this.$nextTick(() => {
      this.$refs.addCostDetailsForm.clearValidate(['salerId']);
    });
    this.loadActivityCostTable();
    if (this.callbackUrl === '/activityDetails') {
      this.loadAdvertCostTable();
    }
    this.getProductLineList();
    this.getExpenseOptionList();
  }
};
</script>

<style lang="scss" scoped>
.addCostDetails{
  .common_readonly_template{
    margin-top: 16px;
    .customStyle>span{
      margin-right: 6px;
    }
  }
}
</style>
